<template>
  <button
    v-if="!user"
    type="button"
    class="btn btn-like"
    @click="requiresAuth(true, requiresAuthRedirect)"
  >
    <i class="icon icon-heart-o" aria-hidden="true"></i>
  </button>
  <button
    v-else
    type="button"
    class="btn btn-like"
    :class="{ 'btn-red': isFavorite }"
    @click="favorite"
  >
    <i
      class="icon"
      :class="{ 'icon-heart': isFavorite, 'icon-heart-o': !isFavorite }"
      aria-hidden="true"
    ></i>
  </button>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    canBeFavorited: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      isFavorite: this.product.is_favorite
    }
  },
  computed: {
    requiresAuthRedirect() {
      return `/produkt/${this.product.id}/oblibit`
    }
  },
  methods: {
    favorite() {
      if (!this.canBeFavorited) {
        return this.tariffRequirement()
      }

      this.isFavorite = !this.isFavorite

      axios.get(`/produkt/${this.product.id}/oblibit`)
    },
    tariffRequirement() {
      this.$swal({
        title: '',
        text: 'Váš tarif nepodporuje funkci přidání inzerátu do seznamu oblíbených.',
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Pokračovat'
      })
    }
  }
}
</script>
